import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import TopBar from '../components/TopBar';
import Home from '../components/Home';
import ProfileReview from '../components/ProfileReview';
import Profile from '../components/Profile';
import SearchCreators from '../components/SearchCreators';
import Settings from '../components/Settings'; // ⬅ adjust path if needed
import AccountInfo from "../components/Settings/AccountInfo";
import Support from "../components/SupportTicketForm";

// NOTE: Stage 1 = no Payments, Projects, ProjectDetail, ProjectForm,
// SupportTicketForm, etc. Settings is now enabled via /dashboard/settings.

const Dashboard = () => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState('home');
  const [darkMode, setDarkMode] = useState(true); // force dark mode by default
  const isSupportRoute = location.pathname.startsWith('/dashboard/support');

  // Detect if we're on /dashboard/settings or any sub-route under it
  const isSettingsRoute = location.pathname.startsWith('/dashboard/settings');
  // More specific: /dashboard/settings/account → AccountInfo
  const isAccountInfoRoute = location.pathname.startsWith('/dashboard/settings/account');

  const renderTab = () => {
    switch (activeTab) {
      case 'profileReview':
        return <ProfileReview />;
      case 'profileEdit':
        return <Profile />;
      case 'findCreators':
        return <SearchCreators />;
      case 'home':
      default:
        return <Home />;
    }
  };

  const studioBackground =
    'radial-gradient(circle at center, #0f172a 0%, #000000 100%)';

  return (
    <div
      style={{
        display: 'flex',
        height: '100vh',
        fontFamily: 'Inter, sans-serif',
        background: studioBackground,
        color: '#F3F4F6',
      }}
    >
      {/* IMPORTANT:
         For Stage 1, make sure your Sidebar in the landing app
         only shows: Home, My Profile (Profile Review), Find Creators.
         Hide Projects, Payments, etc. */}
      <Sidebar setActiveTab={setActiveTab} />

      <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        <TopBar darkMode={darkMode} setDarkMode={setDarkMode} />

        <main
          style={{
            flex: 1,
            padding: '40px',
            paddingTop: 80,
            overflowY: 'auto',
            background: 'rgba(17, 24, 39, 0.95)',
          }}
        >
          {/* ROUTE PRIORITY ORDER */}
          {isAccountInfoRoute ? (
            <AccountInfo />
          ) : isSettingsRoute ? (
            <Settings />
          ) : isSupportRoute ? (
            <Support />
          ) : (
            renderTab()
          )}
        </main>
      </div>
    </div>
  );
};

export default Dashboard;
